import { render, staticRenderFns } from "./ModalWorkRecordsForm.vue?vue&type=template&id=d8315d8e&scoped=true"
import script from "./ModalWorkRecordsForm.vue?vue&type=script&lang=js"
export * from "./ModalWorkRecordsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8315d8e",
  null
  
)

export default component.exports